import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";
import { Navigate } from "react-router-dom";

const FieldHomePage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldHomePage })),
);
const FieldMePage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldMePage })),
);
const FieldMyActivityPage = lazy(() =>
  import("@/modules/mes").then((m) => ({ default: m.FieldMyActivityPage })),
);
const FieldNotificationsPage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldNotificationsPage })),
);
const FieldSettingsPage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldSettingsPage })),
);
const FieldSyncPage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldSyncPage })),
);
const FieldProfilePage = lazy(() =>
  import("@/modules/sys").then((m) => ({ default: m.FieldProfilePage })),
);

export const fieldBaseRoutes: RouteObject[] = [
          { index: true, element: <Navigate to="home" replace /> },
          {
            path: "home",
            element: (
              <LazyPage>
                <FieldHomePage />
              </LazyPage>
            ),
          },
          {
            path: "me",
            element: (
              <LazyPage>
                <FieldMePage />
              </LazyPage>
            ),
          },
          {
            path: "profile",
            element: (
              <LazyPage>
                <FieldProfilePage />
              </LazyPage>
            ),
          },
          {
            path: "activity",
            element: (
              <LazyPage>
                <FieldMyActivityPage />
              </LazyPage>
            ),
          },
          {
            path: "notifications",
            element: (
              <LazyPage>
                <FieldNotificationsPage />
              </LazyPage>
            ),
          },
          {
            path: "settings",
            element: (
              <LazyPage>
                <FieldSettingsPage />
              </LazyPage>
            ),
          },
          {
            path: "sync",
            element: (
              <LazyPage>
                <FieldSyncPage />
              </LazyPage>
            ),
          },
];
